export const SUPPLIER_TYPES = [
  "ACCOMMODATION",
  "ACTIVITY",
  "TRAVEL",
  "TRANSPORT",
  "PACKAGE",
  "OTHER",
];



// WEBPACK FOOTER //
// ./src/constants/supplierTypes.js